import React from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { QuoteLineItemProps } from '@partsbadger/types';
import { ReloadOutlined, UploadOutlined } from '@ant-design/icons';
// import QuoteStore from '../stores/QuoteStore';
import { UploadFile } from '@partsbadger/library';
import { UploadFile as UploadFileInterface } from 'antd/es/upload/interface';

const { Text } = Typography;

type AnalysisStatusDetails = QuoteLineItemProps['product']['analysis_status']['file_3d'];

interface FileAnalysisAlertProps {
    fileType: '3D' | '2D';
    analysisStatus: AnalysisStatusDetails;
    isStaffUser: boolean;
    quoteToken: string;
    reanalyzeMasterProduct: () => void;
    handleOnChange: (fileList: Array<any>) => void;
    handleOnRemove: (file: UploadFileInterface) => void;
}

export const AnalysisAlert: React.FC<FileAnalysisAlertProps> = ({
    fileType,
    analysisStatus,
    isStaffUser,
    quoteToken,
    reanalyzeMasterProduct,
    handleOnChange,
    handleOnRemove,
}) => {
    const is3d = fileType === '3D';
    const message = `${fileType} Analysis Error`;
    const analysisMessage = analysisStatus?.message || 'Unknown error';

    return (
        <Alert
            message={message}
            type="error"
            style={{ marginRight: '6%' }}
            className="p-1"
            description={
                <Space direction="vertical" style={{ width: '100%', gap: '8px' }}>
                    <Text
                        type="danger"
                        style={{
                            fontSize: '12px',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}
                    >
                        {analysisMessage}
                    </Text>
                    {isStaffUser && (
                        <>
                            <Button
                                onClick={() => reanalyzeMasterProduct()}
                                icon={<ReloadOutlined />}
                                size="small"
                                // style={{ width: '100%' }}
                            >
                                Analyze again
                            </Button>
                            or
                        </>
                    )}
                </Space>
            }
        />
    );
};
